var React = require('react');

function ShowAllIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#fff"},React.createElement("g",null,React.createElement("path",{"d":"M27 257v5h5v11H21v-5h-5v-11h11zm4 6h-4v5h-5v4h9v-9zm-5-5h-9v9h4v-5h5v-4zm0 5h-4v4h4v-4z","transform":"translate(-300 -393) translate(284 136)"})))));
}

ShowAllIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ShowAllIcon;

ShowAllIcon.default = ShowAllIcon;
